import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { GlobalService } from '../../shared/services/global/global.service';
import { DmcPackageDetailsComponent } from './package-details/dmc-package-details.component';
import { DmcPackageRouteCraftComponent } from './route-craft/dmc-package-route-craft.component';
import { DmcPackagePricingComponent } from './package-pricing/dmc-package-pricing.component';
import { DmcPackageInclusionsAndExclusionsComponent } from './inclusions-and-exclusions/dmc-package-inclusions-and-exclusions.component';
import { DmcPackageTermsAndConditionsComponent } from './terms-and-conditions/dmc-package-terms-and-conditions.component';
import { DmcPackageCancellationPolicyComponent } from './cancellation-policy/dmc-package-cancellation-policy.component';
import { DmcPackageImportantInformationComponent } from './important-information/dmc-package-important-information.component';
import { DmcPackageNotesComponent } from './package-notes/dmc-package-notes.component';
import { ModalsService } from '../../shared/services/modals/modals.service';
import { DmcPackageService } from 'src/app/business-service/dmc-package/dmc-package.service';
import { DmcPackageTemplateDataComponent } from './template-data/dmc-package-template-data.component';

@Component({
  selector: 'app-dmc-packages-form',
  templateUrl: './dmc-packages-form.component.html',
  styleUrls: ['./dmc-packages-form.component.scss'],
})
export class DmcPackagesFormComponent implements OnInit {
  
  @ViewChild(DmcPackageDetailsComponent) DetailsComponent!: DmcPackageDetailsComponent;
  @ViewChild(DmcPackageRouteCraftComponent) routeCraftComponent!: DmcPackageRouteCraftComponent;
  @ViewChild(DmcPackagePricingComponent) pricingComponent!: DmcPackagePricingComponent;
  @ViewChild(DmcPackageInclusionsAndExclusionsComponent) inclusionAndExclusionComponent!: DmcPackageInclusionsAndExclusionsComponent;
  @ViewChild(DmcPackageTermsAndConditionsComponent) termsAndConditionsComponent!: DmcPackageTermsAndConditionsComponent;
  @ViewChild(DmcPackageCancellationPolicyComponent) cancellationPolicyComponent!: DmcPackageCancellationPolicyComponent;
  @ViewChild(DmcPackageImportantInformationComponent) importantInformationComponent!: DmcPackageImportantInformationComponent;
  @ViewChild(DmcPackageNotesComponent) notesComponent!: DmcPackageNotesComponent;
  @ViewChild(DmcPackageTemplateDataComponent) templatesDetailsComponent!: DmcPackageTemplateDataComponent;

  packageId: any;
  editPackageId:any;

  allPackageData:any;

  packageDetailsFormData:any;
  routeCraftFormData:any;
  pricingFormData:any;
  transfersFormData:any;
  optinalSightseeingFormData:any;
  inclusionsAndExclusionsFormData:any;
  termsAndConditionsFormData:any;
  cancellationPolicyFormData:any;
  importantInformationFormData:any;
  notesFormData: any;
  templatesDetailsFormData:any;

  orderOfTabs: string[] = ['details', 'route', 'pricing', 'inclusions', 'combined-terms', 'important', 'notes', 'templates-details'];
  orderOfTabsIndex: number = 0;
  componentView: string = this.orderOfTabs[this.orderOfTabsIndex];

  constructor(
    private _modalController: ModalController,
    private _globalService: GlobalService,
    private _modalService: ModalsService,
    private _dmcPackageService: DmcPackageService
  ) { }

  ngOnInit() {
    const organizationId = localStorage.getItem('CId');
    if(this.editPackageId){
      this._dmcPackageService.getPackage(this.editPackageId, organizationId).subscribe({
        next: (res)=>{
          this.allPackageData = res;          
          if(this.allPackageData){
            this.assignPackageDataTabs();
            this.assignPackageId(this.packageDetailsFormData.packageId);
          }
        },
        error: (err) => {
          console.error("Error in getting package", err);
        }
      })
    }
  }

  assignPackageDataTabs(){
    this.packageDetailsFormData = this.allPackageData.dmcPackages ? 
    { ...this.packageDetailsFormData , ...this.allPackageData.dmcPackages}: null;

    this.routeCraftFormData = this.allPackageData.routeCraftDmc? 
    {...this.routeCraftFormData,...this.allPackageData.routeCraftDmc}: null;

    this.pricingFormData = this.allPackageData.hotelPricingCollection ? 
    {...this.pricingFormData,...this.allPackageData.hotelPricingCollection}: null;

    this.transfersFormData = this.allPackageData.transfersPackage? 
    {...this.transfersFormData,...this.allPackageData.transfersPackage}: null;

    this.optinalSightseeingFormData = this.allPackageData.optionalSightSeeing? 
    {...this.optinalSightseeingFormData,...this.allPackageData.optionalSightSeeing}: null;

    this.inclusionsAndExclusionsFormData = this.allPackageData.inclusionAndExclusions ? 
    {...this.inclusionsAndExclusionsFormData,...this.allPackageData.inclusionAndExclusions }: null;
    
    this.termsAndConditionsFormData = this.allPackageData.termsAndConditions ?
    {...this.termsAndConditionsFormData,...this.allPackageData.termsAndConditions }: null;

    this.cancellationPolicyFormData = this.allPackageData.cancellationPolicies ?
    {...this.cancellationPolicyFormData,...this.allPackageData.cancellationPolicies}: null;

    this.importantInformationFormData = this.allPackageData.importantInformations ?
    {...this.importantInformationFormData,...this.allPackageData.importantInformations }: null;
    
    this.notesFormData = this.allPackageData.notes ?
    {...this.notesFormData,...this.allPackageData.notes}: null;

    this.templatesDetailsFormData = this.allPackageData.template ?
    {...this.templatesDetailsFormData,...this.allPackageData.template}: null;
    this.makeAvalibleTabsGreen();
  }

  makeAvalibleTabsGreen(){
    if(this.packageDetailsFormData){
      this.packageDetailsFormData.dataSaved = true;
    }
    if(this.routeCraftFormData){
      this.routeCraftFormData.dataSaved = true;
    }
    if(this.pricingFormData){
      this.pricingFormData.dataSaved = true;
    }
    if(this.transfersFormData){
      this.transfersFormData.dataSaved = true;
    }
    if(this.optinalSightseeingFormData){
      this.optinalSightseeingFormData.dataSaved = true;
    }
    if(this.inclusionsAndExclusionsFormData){
      this.inclusionsAndExclusionsFormData.dataSaved = true;
    }
    if(this.termsAndConditionsFormData){
      this.termsAndConditionsFormData.dataSaved = true;
    }
    if(this.cancellationPolicyFormData){
      this.cancellationPolicyFormData.dataSaved = true;
    }
    if(this.importantInformationFormData){
      this.importantInformationFormData.dataSaved = true;
    }
    if(this.notesFormData){
      this.notesFormData.dataSaved = true;
    }
    if(this.templatesDetailsFormData){
      this.templatesDetailsFormData.dataSaved = true;
    }
  }

  async closeModal() {
    if (this.checkCurrentFormDirty(this.componentView)) {
      let res = await this._globalService.confirmTabChangeAction("You have unsaved data, do you want to Proceed?", "Unsaved Data / Invalid Form", "Save & Proceed", "Proceed")
      switch (res) {
        case 'saveProceed': {
          if(await this.saveDataOfCurrentForm(this.componentView)){
            this.dismissModal();
          }else{
            console.error("failed to save");
          }
          break
        }
        case 'proceed': {
          this.dismissModal();
          break;
        }
      }
    } else {
      this.dismissModal();
    }
  }

  dismissModal(){
    this._modalController.dismiss();
  }

  async onViewChangeFromTab(view: string) {
    if (this.checkCurrentFormDirty(this.componentView)) {
      let res = await this._globalService.confirmTabChangeAction("You have unsaved data, do you want to Proceed?", "Unsaved Data / Invalid Form", "Save & Proceed", "Proceed")
      switch (res) {
        case 'saveProceed': {
          if(await this.saveDataOfCurrentForm(this.componentView)){
            this.changeComponentView(view);
          }else{
            console.error("failed to save");
          }
          break
        }
        case 'proceed': {
          this.changeComponentView(view);
          break;
        }
      }
    } else {
      this.changeComponentView(view);
    }
  }

  changeComponentView(view: any) {
    this.componentView = view;
    this.orderOfTabsIndex = this.orderOfTabs.indexOf(view);
  }

  async onViewChange(goPrevious: any) {
    if (goPrevious) {
      this.orderOfTabsIndex--;
      this.componentView = this.orderOfTabs[this.orderOfTabsIndex];
    } else {
      this.orderOfTabsIndex++;
      this.componentView = this.orderOfTabs[this.orderOfTabsIndex];
    }
  }

  assignPackageId(packageId: string) {
    this.packageId = packageId;
    this.getTemplateDetails(this.packageId);
  }
  
  // Funtions to store emitted data from child comps in parent
  storePackageDetailsData(formData:any){
    this.packageDetailsFormData = {
      ...formData, dataSaved: true, dataInvalid: false
    }
  }
  storeRouteCraftData(formData:any){
    this.routeCraftFormData = {
     ...formData, dataSaved: true, dataInvalid: false
    }
  }
  storePricingData(formData:any){
    this.pricingFormData = {
     ...formData, dataSaved: true, dataInvalid: false
    }
  }
  storeTransfersData(formData:any){
    this.transfersFormData = {
     ...formData, dataSaved: true, dataInvalid: false
    }
  }
  storeOptinalSightseeingData(formData:any){
    this.optinalSightseeingFormData = {
     ...formData, dataSaved: true, dataInvalid: false
    }
  }
  storeInclusionsAndExclusionsData(formData:any){
    this.inclusionsAndExclusionsFormData = {
     ...formData, dataSaved: true,dataInvalid: false
    }
  }
  storeTermsAndConditionsData(formData:any){
    this.termsAndConditionsFormData = {
     ...formData, dataSaved: true, dataInvalid: false
    }
  }
  storeCancellationPolicyData(formData:any){
    this.cancellationPolicyFormData = {
     ...formData, dataSaved: true, dataInvalid: false
    }
  }
  storeImportantInformationData(formData:any){
    this.importantInformationFormData = {
     ...formData, dataSaved: true, dataInvalid: false
    }
  }
  storeNotesData(formData:any){
    this.notesFormData = {
     ...formData, dataSaved: true, dataInvalid: false
    }
  }
  storeTemplateDetailsData(formData:any){
    this.templatesDetailsFormData = {
     ...formData, dataSaved: true, dataInvalid: false
    }
  }

  getTemplateDetails(quoteId: any) {
    const organizationId = localStorage.getItem('CId');
    this._dmcPackageService.getPackage(quoteId, organizationId).subscribe((data) => {
      this.templatesDetailsFormData = data.template;
      this.templatesDetailsFormData.dataSaved = true;
    })
  }
  
  checkCurrentFormDirty(view: any): any {
    switch (view) {
      case 'details': {
        return (this.DetailsComponent?.formDataModified());
      }
      case 'route': {
        return (this.routeCraftComponent?.formDataModified());
      }
      case 'pricing': {
        return (this.pricingComponent?.formDataModified());
      };
      case 'inclusions': {
        return (this.inclusionAndExclusionComponent?.formDataModified());
      };
      case 'terms': {
        return (this.termsAndConditionsComponent?.formDataModified());
      };
      case 'cancellation': {
        return (this.cancellationPolicyComponent?.formDataModified());
      };
      case 'important': {
        return (this.importantInformationComponent?.formDataModified());
      };
      case 'notes': {
        return (this.notesComponent?.formDataModified());
      };
      case 'templates-details': {
        return (this.templatesDetailsComponent?.formDataModified());
      }
      default: {
        return false;
      }
    }
  }

  async saveDataOfCurrentForm(view: any) {
    switch (view) {
      case 'details': {
        return (this.DetailsComponent?.onSubmit());
      }
      case 'route': {
        return (this.routeCraftComponent?.onSubmit());
      }
      case 'pricing': {
        return (this.pricingComponent?.onAllFormsSubmit());
      };
      case 'inclusions': {
        return (this.inclusionAndExclusionComponent?.onSubmit());
      };
      case 'terms': {
        return (this.termsAndConditionsComponent?.onSubmit());
      };
      case 'cancellation': {
        return (this.cancellationPolicyComponent?.onSubmit());
      };
      case 'important': {
        return (this.importantInformationComponent?.onSubmit());
      };
      case 'notes': {
        return (this.notesComponent?.onSubmit());
      };
      case 'templates-details': {
        return (this.templatesDetailsComponent?.onSubmit());
      }
      default: {
        return false;
      }
    }
  }

  async openReviewScreen() {
    if (this.checkCurrentFormDirty(this.componentView)) {
      let res = await this._globalService.confirmTabChangeAction("You have unsaved data, do you want to Proceed?", "Unsaved Data / Invalid Form", "Save & Proceed", "Proceed")
      switch (res) {
        case 'saveProceed': {
          if (await this.saveDataOfCurrentForm(this.componentView)) {
            this.openQuoteReview();
          }
          break
        }
        case 'proceed': {
          this.openQuoteReview();
          break;
        }
      }
    } else {
      this.openQuoteReview();
    }
  }

  async openQuoteReview() {
    if (this.isPackageDataValid()) {
      await this._modalService.closeAllModals();
      this._modalService.openDmcPackageReview(this.packageId);
    } else {
      this._globalService.customAlert("Validate all sections", "Quote is invalid");
    }

  }

  isPackageDataValid(): boolean {
    // TODO: checl and return bool based in pacakge data is invalid
    return true;
  }

  onDestinationsDataChanged(){
    if(this.routeCraftFormData){
      this.routeCraftFormData.dataInvalid = true;
    }
    if(this.pricingFormData){
      this.pricingFormData.dataInvalid = true;
    }
  }
}
